// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class Int64StringKeyValuePair {
    static getAttributeTypeMap() {
        return Int64StringKeyValuePair.attributeTypeMap;
    }
}
Int64StringKeyValuePair.discriminator = undefined;
Int64StringKeyValuePair.additionalProperties = false;
Int64StringKeyValuePair.attributeTypeMap = [
    {
        "name": "key",
        "baseName": "key",
        "type": "number"
    },
    {
        "name": "value",
        "baseName": "value",
        "type": "string"
    },
];
//# sourceMappingURL=int64StringKeyValuePair.js.map